import { WalletBase } from '../WalletBase';
import { ISignResult } from '../types';

export class PetraWallet extends WalletBase {
  authType = 'Petra';
  init(): void {
    if ('aptos' in window) {
      const provider = window.aptos;

      this.provider = provider;
    } else {
      window.open('https://petra.app/', `_blank`);
    }
  }

  async connect(): Promise<boolean> {
    const provider = this.provider; // see "Detecting the Provider"
    if (!provider) return false;
    try {
      const resp = await provider.connect();
      const account = await provider.account();
      console.log(resp, account);
      this.address = account.address;
      this.publicKey = account.publicKey;
      this.isConnected = true;
      return true;
    } catch (err) {
      // { code: 4001, message: 'User rejected the request.' }
      return false;
    }
  }
  async sign(message: string, nonce?: string): Promise<ISignResult> {
    const provider = this.provider;
    const signedMessage = await provider.signMessage({
      nonce: nonce || Date.now(),
      message: message
    });
    return {
      message: signedMessage.fullMessage,
      signature: signedMessage?.signature
    };
  }
}
